<template>
  <div>
    <Datepicker
      v-bind="dynamicIdAttr"
      ref="datepicker"
      :input-class-name="disabledClasses"
      :disabled="disabled"
      :readonly="readonly"
      :model-value="formatedValue"
      :value="formatedValue"
      :max-date="max"
      :start-date="startDate"
      :enable-time-picker="enableTimePicker"
      :teleport-center="isMobile"
      :flow="flow"
      :name="name"
      :placeholder="placeholder"
      :locale="locale"
      :format="displayFormat"
      :clearable="false"
      no-today
      time-picker-inline
      @update:model-value="onUpdateModelValue"
    >
      <template #action-row="{ internalModelValue, selectDate }">
        <div class="action-row w-full">
          <p class="pb-3 text-center font-medium text-black">
            {{ internalModelValue ? formatDate(internalModelValue) : "" }}
          </p>
          <div class="flex space-x-2">
            <ButtonBase
              theme="primaryTransparent"
              size="none"
              class="w-1/2 py-1"
              @click="onCloseMenu"
            >
              {{ $t("action.cancel") }}
            </ButtonBase>
            <ButtonBase
              theme="primary"
              size="none"
              class="w-1/2 py-1"
              @click="selectDate"
              :class="{
                'pointer-events-none bg-opacity-20': !internalModelValue,
              }"
            >
              {{ $t("action.choose") }}
            </ButtonBase>
          </div>
        </div>
      </template>

      <template #dp-input="{ value }">
        <BaseInput
          :inputGroupClasses="['cursor-pointer rounded-[8px] relative']"
          inputClasses="pointer-events-none"
          :name="name"
          :value="value"
          :label="label"
          :readonly="readonly"
          :disabled="disabled"
          :placeholder="placeholder"
          :errors="errors"
        >
          <img
            class="absolute right-4 top-1/2 h-[17px] w-[17px] -translate-y-1/2 transform cursor-pointer"
            src="@/assets/images/base/icons/calendar-input.svg"
            loading="lazy"
          />
        </BaseInput>
      </template>
    </Datepicker>
  </div>
</template>

<script>
import moment from "moment";
import isMobile from "@/mixins/isMobile";
import ButtonBase from "@/components/Core/ButtonBase.vue";
import BaseInput from "@/components/Core/BaseInput.vue";

export default {
  name: "BaseDatePicker",
  components: { ButtonBase, BaseInput },
  mixins: [isMobile],
  emits: ["input", "update:value"],
  props: {
    value: {
      type: [String, Number, Date, null],
      required: true,
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "dd.mm.yyyy",
    },
    enableTimePicker: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    anyDirty: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Object,
      default: null,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    max: {
      type: [Date, String],
      default: () => new Date(),
    },
    startDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    flow: {
      type: Array,
      default: () => ["year", "month", "calendar", "time"],
    },
    displayFormat: {
      type: String,
      default: "dd.MM.yyyy",
    },
    outputFormat: {
      type: String,
      default: "YYYY-MM-DD",
    },
  },
  computed: {
    locale() {
      switch (this.$root.$i18n.locale) {
        case "ua":
          return "uk";
        default:
          return this.$root.$i18n.locale;
      }
    },
    formatedValue() {
      return moment(this.value, this.outputFormat).toString();
    },
    disabledClasses() {
      return this.disabled || this.readonly ? "readonly" : "";
    },
    dynamicIdAttr() {
      return this.id ? { id: this.id } : {};
    },
  },
  methods: {
    onUpdateModelValue(value) {
      if (value === null) {
        this.$emit("update:value", "");
        return this.$emit("input", "");
      }
      this.$emit("input", moment(value).format(this.outputFormat));
      this.$emit("update:value", moment(value).format(this.outputFormat));
    },
    onCloseMenu() {
      this.$refs.datepicker.closeMenu();
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
  },
};
</script>
